import { PrimaryButton,TextField,Stack,Text, Label,DefaultEffects,Dropdown } from '@fluentui/react';
import React,{useState,useEffect } from 'react';


function Length()
{
    useEffect(() => {
        document.title = "길이 계산기";  
        }, []);
    const unitOptions =[
        { key: 'mm', text: '밀리미터(mm)' },
        { key: 'cm', text: '센치미터(cm)' },
        { key: 'm', text: '미터(m)' },
        { key: 'km', text: '킬로미터(km)' },
        { key: 'in', text: '인치(in)' },
        { key: 'ft', text: '피트(ft)' },
        { key: 'yd', text: '야드(yd)' },
    ]
    const [valState,setValState] = useState(0);
    const [unitState,setUnitState] = useState({ key: 'mm', text: '밀리미터(mm)' });
    const [state,setState] = useState({
        mm:'0',
        cm:'0',
        m:'0',
        km:'0',
        in:'0',
        ft:'0',
        yd:'0',
    });
    function getmmValue(value, unit)
    {
        if(unit == 'mm')
        {
            return value;
        }
        if(unit == 'cm')
        {
            return value*10;
        }
        if(unit == 'm')
        {
            return value*1000;
        }
        if(unit == 'km')
        {
            return value*1000000;
        }
        if(unit == 'in')
        {
            return value*25.4;
        }
        if(unit == 'ft')
            return value*304.8;
        if(unit == 'yd')
            return value*0.333333;
        return 0;
    }
    function getmmTo(value, unit)
    {
   
        if(unit == 'mm')
        {
            return value;
        }
        if(unit == 'cm')
        {
            return value/10;
        }
        if(unit == 'm')
        {
            return value/1000;
        }
        if(unit == 'km')
        {
            return value/1000000;
        }
        if(unit == 'in')
        {
            return value*0.03937;
        }
        if(unit == 'ft')
            return value*0.003281;
        if(unit == 'yd')
            return value*0.001094;
        return 0;
    }
    function curValChange(e)
    {
        setValState(parseInt(e.target.value));
        calcul(parseInt(e.target.value),unitState);
    }
    function unitChange(op)
    {
        setUnitState(op);
        calcul(valState,op);
    }
    function calcul(value,op)
    {
        let newState = {
            mm:'0',
            cm:'0',
            m:'0',
            km:'0',
            in:'0',
            ft:'0',
            yd:'0',
        };
    
        let mmValue = getmmValue(value, op.key);
        console.log(mmValue);
        newState.mm = getmmTo(mmValue,'mm');
        newState.cm = getmmTo(mmValue,'cm');
        newState.m = getmmTo(mmValue,'m');
        newState.km = getmmTo(mmValue,'km');
        newState.in = getmmTo(mmValue,'in');
        newState.ft = getmmTo(mmValue,'ft');
        newState.yd = getmmTo(mmValue,'yd');
        setState(newState);

    }
    let transUnitValueList = unitOptions.map((unit) =>
    <li key={unit.key}> <Text variant="large" >{`${state[unit.key]} ${unit.text}`}</Text></li>
    );
    return (
        <Stack.Item  align='center' tokens={{ }} >
            <Stack tokens={{childrenGap:10}} >
                <Stack.Item><Text variant="superLarge" style={{marginBottom:40}}>길이 계산기</Text></Stack.Item>
                <Stack.Item><Text variant="large" style={{marginTop:10}}>길이 단위를 변환 합니다.</Text></Stack.Item>
                <Stack horizontal wrap tokens={{childrenGap:10}}>
                    <Stack.Item><TextField type='number' name='val' onChange={function(e){ curValChange(e);  } } placeholder='0' /></Stack.Item>
                    <Stack.Item><Dropdown onChange={(e,selectedOption)=>unitChange(selectedOption)} styles={{width:300}} defaultSelectedKey='mm' selectedKey={unitState.key} options={unitOptions} /> </Stack.Item>     
                </Stack>
                <ul>
                   {transUnitValueList}
                </ul>
            </Stack>
        </Stack.Item>

    );
}

export default Length;